import React from 'react';

import Modal from 'common-ui/modal';

import { OrderItem, OrderList, OrderMeta, OrderName } from './OrderSelectModal.styles';

const OrderSelectModal = ({ isOpen, onClose, orders, onSelect }) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Select Order" closeIcon>
    <OrderList>
      {orders.map((order) => (
        <OrderItem
          key={order.id}
          onClick={() => {
            onSelect(order.id);
            onClose();
          }}
        >
          <OrderName>{order.offerName}</OrderName>
          <OrderMeta>
            {order.qty && `Qty: ${order.qty}`}
            {order.qty && order.status && ' • '}
            {order.status && `Status: ${order.status}`}
          </OrderMeta>
        </OrderItem>
      ))}
    </OrderList>
  </Modal>
);

export default OrderSelectModal;
